import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { editorTheme } from '../../../theme';

interface StyleProps {
  color?: string;
}

const StyledSpan = styled.span<StyleProps>`
  font-weight: 600;
  color: ${({ color = editorTheme.text }) => color};
  font-size: 13px;
  line-height: 20px;
  padding: 12px 0 8px;
  display: block;
`;

const Span: FC<PropsWithChildren & StyleProps> = (props) => (
  <StyledSpan {...props} />
);

export default Span;
